// src/lib/safe-json-stringify.ts
function safeJsonStringify(value, replacer, space) {
  return JSON.stringify(value, replacer, space).replace(/</g, "\\u003c");
}

export {
  safeJsonStringify
};
//# sourceMappingURL=chunk-2UDLZC33.js.map